/**
 * Takes the baseObject and overrides the values present in objectOverrides at any level in the object's data structure.
 * The function ensures that baseObject doesn't lose any property and only the values present in objectOverrides are
 * updated in baseObject. This function can be resource intensive so it should be used carefully.
 * @param {Object} baseObject  An object containing a set of properties arbitrary levels deep.
 * @param {Object} objectOverrides An object having the same data structure as objectOverrides that will be used to
 * override the equivalent values present in baseObject.
 * @returns {Object}  An object based on baseObject but having the modifications described by objectOverrides
 */
// FIXME this function is repeated in WVL (called overrideDefaultTheme in StyleProvider.js), move to a common dependency
export default function deepMerge(baseObject, objectOverrides) {
  for (let property in objectOverrides) {
    if (objectOverrides.hasOwnProperty(property)) {
      if (objectOverrides[property] !== null && typeof objectOverrides[property] === "object") {
        baseObject[property] = baseObject[property] || {};
        deepMerge(baseObject[property], objectOverrides[property]);
      } else {
        baseObject[property] = objectOverrides[property];
      }
    }
  }
  return baseObject;
}
